/** Great-circle distance in kilometres between two coordinates. */
export const haversineKm = (aLat: number, aLon: number, bLat: number, bLon: number): number => {
    const toRad = (deg: number) => (deg * Math.PI) / 180
    const dLat = toRad(bLat - aLat)
    const dLon = toRad(bLon - aLon)
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) * Math.sin(dLon / 2) ** 2
    return 2 * 6371 * Math.asin(Math.sqrt(h))
}
